export const AdminContractsViolet = () => {
	return (
		<svg
			width="61"
			height="62"
			viewBox="0 0 61 62"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M55.9487 32.948L57.5019 27.1513C59.315 20.3848 60.2215 17.0015 59.5388 14.0736C58.9998 11.7618 57.7873 9.66172 56.0547 8.03898C53.8604 5.98381 50.4772 5.07727 43.7106 3.26418C36.9441 1.45109 33.5608 0.544541 30.6329 1.22723C28.3211 1.76627 26.221 2.97874 24.5983 4.71132C22.8387 6.59002 21.9211 9.34033 20.5556 14.3394C20.3262 15.1791 20.0842 16.0823 19.8235 17.0554L18.2703 22.8521C16.4572 29.6186 15.5506 33.0019 16.2333 35.9298C16.7724 38.2416 17.9848 40.3417 19.7174 41.9644C21.9117 44.0196 25.295 44.9261 32.0615 46.7392L32.0615 46.7392C38.1605 48.3734 41.5108 49.2712 44.2565 48.9325C44.5571 48.8954 44.8504 48.8435 45.1392 48.7762C47.4511 48.2371 49.5511 47.0247 51.1738 45.2921C53.229 43.0978 54.1356 39.7145 55.9487 32.948Z"
				fill="#E8E8E8"
				stroke="#454545"
			/>
			<path
				d="M44.2533 48.929C43.6277 50.8448 42.5277 52.578 41.0486 53.9633C38.8543 56.0184 35.4711 56.925 28.7045 58.7381C21.938 60.5512 18.5547 61.4577 15.6268 60.775C13.315 60.236 11.2149 59.0235 9.5922 57.2909C7.53703 55.0966 6.63048 51.7134 4.81739 44.9468L3.26418 39.1501C1.45109 32.3836 0.544541 29.0003 1.22723 26.0724C1.76627 23.7606 2.97874 21.6606 4.71132 20.0378C6.9056 17.9827 10.2889 17.0761 17.0554 15.263C18.3356 14.92 19.4946 14.6094 20.5524 14.3359"
				stroke="#454545"
			/>
			<path
				d="M30.3383 25.0156L44.8299 28.8987"
				stroke="#454545"
				strokeLinecap="round"
			/>
			<path
				d="M28.0042 33.6953L36.6992 36.0251"
				stroke="#454545"
				strokeLinecap="round"
			/>
		</svg>
	);
};
